import { IvCertCircuitDocumentP } from "../../../api";

export class StatusBarModel {
    private _text: string;
    private _signerName: string;
    private _signerEmail: string;
    private _documentTitle: string;
    private _signatureDocuments: IvCertCircuitDocumentP[];
    private _hasSelectedDocument: boolean;
    
    constructor() {
        this.signatureDocuments = new Array<IvCertCircuitDocumentP>();
    }

    get text(): string {
        return this._text;
    }

    set text(value: string) {
        this._text = value;
    }

    get signerName(): string {
        return this._signerName;
    }

    set signerName(value: string) {
        this._signerName = value;
    }

    get signerEmail(): string {
        return this._signerEmail;
    }

    set signerEmail(value: string) {
        this._signerEmail = value;
    }

    get documentTitle(): string {
        return this._documentTitle;
    }

    set documentTitle(value: string) {
        this._documentTitle = value;
    }

    get signatureDocuments(): IvCertCircuitDocumentP[] {
        return this._signatureDocuments;
    }

    set signatureDocuments(value: IvCertCircuitDocumentP[]) {
        this._signatureDocuments = value;
    }

    get hasSelectedDocument(): boolean {
        return this._hasSelectedDocument;
    }

    set hasSelectedDocument(value: boolean) {
        this._hasSelectedDocument = value;
    }
}
